import { DomainIpFormValue, DomainIpItem } from '@nirvana/shared/dtos/types/policies/common';
import { Column, ColumnKeys } from './grid-config';
import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { sortByColumn } from '../../utils/sorters';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';

export class GzExchangeProtectionAntiSpoofingDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  DomainIpItem
> {
  sortByColumnMethod(a: DomainIpItem, b: DomainIpItem, sortColumnName: string, sortDirection: string): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  protected getItemsWithAdditionalFrontendFields(items: DomainIpFormValue[]): DomainIpItem[] {
    return items.map(item => {
      return {
        ...item,
        ipsCount: item.ips.length,
        ipsString: item.ips.join('; '),
      };
    });
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.DOMAIN);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.IP_MASK);
    return;
  }
}
